/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
	name: "clubcolor",
})

/**
 * Authレベルカラー
 *
 * @since 0.01
 */
export class ClubcolorPipe implements PipeTransform {

	/**
	 *
	 * @param value
	 * @param disabled
	 */
	public transform(value: number = 0, disabled: boolean): string {
		const hue = 360 - ((360 / 16) * value);
		let luminance = 95;
		let saturation = 100;

		if (value === 0) {
			luminance = 100;
		}

		if (disabled) {
			luminance = 95;
			saturation = 0;
		}

		return "hsl(" + hue + ", " + saturation + "%, " + luminance + "%)";
	}

}









